export const playersColorsConst = [
    '#fff200',
    '#00d7ff',
    '#ff4296',
    '#ff0028',
    '#00ffbc'
]
